<mat-toolbar>
  <div>
    Any
    <button md-icon-button (click)="changeData('year', -1)">
      <mat-icon>keyboard_arrow_left</mat-icon>
    </button>
      {{year}}
    <button md-icon-button (click)="changeData('year', 1)">
      <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
  </div>
  <div>
    Setmana
    <button md-icon-button (click)="changeData('week', -1)">
      <mat-icon>keyboard_arrow_left</mat-icon>
    </button>
       {{weekNumber}}
    <button md-icon-button (click)="changeData('week', 1)">
      <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
  </div>
</mat-toolbar>
